var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { SellerBio } from './components';
import { RatingSummary } from './components/Ratings';
import { colorPalette } from '../../../colorPalette';
import { BasicSelect } from '../../BasicSelect';
import { ReviewComment } from './components/ReviewComment';
export const SellerReview = ({ seller, sellerType, sortText, commentText, loadMoreText, translatedOptions, newVendorText, saleText, salesText, largeSalesText, textOn, reviews, hasMoreReview, reviewLoading: isLoading, getMoreReviews, setSortOrder, setSortType, setNextToken, setReviews, }) => {
    const ref = useRef(null);
    const handleChangeFilter = (event) => __awaiter(void 0, void 0, void 0, function* () {
        setNextToken(undefined);
        setReviews(undefined);
        switch (event.target.value) {
            case 'CREATION_DATE_DESC':
                setSortType('CREATION_DATE');
                setSortOrder('DESC');
                break;
            case 'CREATION_DATE_ASC':
                setSortOrder('ASC');
                setSortType('CREATION_DATE');
                break;
            case 'RATE_DESC':
                setSortType('RATE');
                setSortOrder('DESC');
                break;
            case 'RATE_ASC':
                setSortType('RATE');
                setSortOrder('ASC');
                break;
            default:
                break;
        }
    });
    const sortsOptions = [
        {
            value: 'CREATION_DATE_DESC',
            label: 'Les plus récents',
            ts: '',
        },
        {
            value: 'CREATION_DATE_ASC',
            label: 'Les plus anciens',
            ts: '',
        },
        {
            value: 'RATE_DESC',
            label: 'Les meilleures notes',
            ts: '',
        },
        {
            value: 'RATE_ASC',
            label: 'Les moins bonnes notes',
            ts: '',
        },
    ];
    const scrollToTop = () => {
        var _a;
        if (ref && ref.current) {
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };
    const sortOptions = translatedOptions || sortsOptions;
    return (React.createElement(Stack, { component: "div", sx: {
            height: {
                xs: '62vh',
                sm: '68vh',
                md: '73vh',
            },
            overflow: 'auto',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            msOverflowStyle: 'none',
            'scrollbar-width': 'none',
        }, ref: ref, spacing: 2 },
        React.createElement(Stack, { component: "div", sx: {
                borderBottom: `8px solid ${colorPalette.gray100}`,
                padding: '17px',
            } },
            React.createElement(SellerBio, { seller: seller, sellerType: sellerType }),
            React.createElement(Stack, { direction: "row", padding: "16px 0", justifyContent: "center", alignItems: "center", spacing: 3 },
                React.createElement(RatingSummary, { numberOfSales: seller === null || seller === void 0 ? void 0 : seller.numberOfSale, sellerRating: seller === null || seller === void 0 ? void 0 : seller.sellerRating, newVendorText: newVendorText, saleText: saleText, salesText: salesText, largeSalesText: largeSalesText, textOn: textOn }))),
        React.createElement(Stack, { alignItems: "center", justifyContent: "center", style: {
                paddingLeft: '16px',
                paddingRight: '16px',
            } },
            React.createElement(Box, { width: "100%" },
                React.createElement(BasicSelect, { label: sortText || "Trier par", onChange: handleChangeFilter, sx: {
                        width: '100%',
                    } }, sortOptions.map((sort, i) => (React.createElement(MenuItem, { key: i, value: sort.value }, sort.label)))))),
        React.createElement(Stack, { gap: 1, sx: {
                paddingLeft: '16px',
                paddingRight: '16px',
            } }, isLoading && (reviews === null || reviews === void 0 ? void 0 : reviews.length) === 0 ? (React.createElement(Stack, { width: "100%", justifyContent: "center", alignItems: "center" },
            React.createElement(CircularProgress, null))) : (reviews &&
            reviews.map((rating, i) => {
                return React.createElement(ReviewComment, Object.assign({ key: i }, rating, { isLoading: isLoading }));
            }))),
        React.createElement(Stack, { alignItems: "center", justifyContent: "center", padding: "16px", paddingBottom: "20px", spacing: 2 },
            React.createElement(Typography, { sx: {
                    fontSize: '14px',
                    color: colorPalette.gray700,
                } },
                (reviews === null || reviews === void 0 ? void 0 : reviews.length) || 0,
                "\u2002",
                commentText || 'avis'),
            React.createElement(Button, { variant: "text", color: "secondary", disabled: !hasMoreReview, onClick: getMoreReviews }, loadMoreText || 'Charger plus d\'avis +')),
        React.createElement(Fab, { sx: {
                position: 'absolute',
                bottom: {
                    xs: 60,
                    md: 8,
                },
                right: 16,
                backgroundColor: 'white',
                boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.12);',
            }, onClick: scrollToTop },
            React.createElement(ArrowUpwardIcon, null))));
};
